import { lazyLoad } from 'app/utils/loadable';

export const ActivationErrorPage = lazyLoad(
  () => import('./activation-error-page'),
  (module) => module.ActivationErrorPage
);
